import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Video } from '../video.model';

@Component({
  selector: 'miniature',
  template: `
    <div (click)="markViewed()" class="new-story -eva-3-m-sm -eva-3-halign" [attr.data-video-id]="video.id" [ngClass]="{'viewed': viewed}">
      <div class="miniature">
        <img [width]="miniatureWidth" [src]="'//media.staticontent.com/media/pictures/' + video.image.src + '/52x52?op=TRUNCATE'" loading="lazy" alt="miniature">
      </div>
    </div>
    <div class="title eva-3-body-2 -eva-3-m-xsm -eva-3-halign">
      <span [title]="video.title">{{video.title}}</span>
    </div>
  `,
  styleUrls: ['./miniature.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class MiniaturesComponent {
  @Input() video: Video;
  @Input() miniatureWidth: number = 100;
  @Input() clickCallback: Function;
  viewed: boolean = false;

  markViewed() {
    this.viewed = true;
    this.clickCallback != null && this.clickCallback();
  }
}
